export default defineNuxtRouteMiddleware(async () => {
  const teams = useTeamsStore()
  if (teams.teams.length == 0) {
    await teams.getAll()
  }
  if (!teams.selected) {
    if (teams.teams.length === 0) {
      return navigateTo('/portal/teams/create')
    }
    if (teams.teams.length === 1) {
      teams.selected = teams.teams[0]
      return
    }
    return navigateTo('/portal/teams/select')
  }
})
